import { render, staticRenderFns } from "./ProductGridNewComponent.vue?vue&type=template&id=b7c91f5e&scoped=true&"
import script from "./ProductGridNewComponent.vue?vue&type=script&lang=ts&"
export * from "./ProductGridNewComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGridNewComponent.vue?vue&type=style&index=0&id=b7c91f5e&scoped=true&lang=css&"
import style1 from "./ProductGridNewComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c91f5e",
  null
  
)

export default component.exports